var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsupimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31784 2.57736C8.31784 1.07845 7.61128 0 6.45413 0C5.81822 0 5.60006 0.369509 5.37197 1.22761C5.32549 1.40499 5.30256 1.49154 5.27838 1.57625C5.21578 1.7966 5.1067 2.17163 4.95175 2.70012C4.94752 2.71423 4.94126 2.72767 4.93316 2.74002L3.15745 5.49353C2.73703 6.14465 2.11682 6.64506 1.38795 6.92124L1.09479 7.03234C0.720461 7.17433 0.408643 7.44243 0.214129 7.78953C0.0196161 8.13663 -0.0451463 8.54052 0.0312228 8.93022L0.281619 10.2106C0.354893 10.5849 0.534937 10.9305 0.80043 11.2066C1.06592 11.4827 1.40574 11.6777 1.77966 11.7684L6.50743 12.9163C7.26115 13.0991 8.05729 12.9799 8.7227 12.5845C9.38811 12.1891 9.86897 11.5495 10.0607 10.8048L10.9377 7.39816C11.0134 7.10365 11.0202 6.79589 10.9575 6.49838C10.8948 6.20087 10.7643 5.92149 10.576 5.68155C10.3876 5.44161 10.1464 5.24746 9.87075 5.11392C9.59508 4.98038 9.29224 4.91099 8.98536 4.91104H7.8561C8.16352 3.9087 8.31846 3.1353 8.31846 2.57736H8.31784Z",
    fill: "#0082B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupimg);
export default __webpack_public_path__ + "static/media/thumbsupimg.534ee0c46cadced143231ec0f5985300.svg";
export { ForwardRef as ReactComponent };